// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"927df0eb8b685ff57705","50143":"9476f95a98c439d0e640","50169":"8de2516e5b8886b737ae","58589":"06360f86bc21ec1de6a0","96914":"12c43b17d147c74de66c"}[chunkId] + ".min.js";
};